import React from 'react';

import {Box, Card, CardContent, CardHeader, Stack, TextField, Typography} from '@mui/material';
import {useQuery} from 'react-query';

import API, {Types, VehicleGetProps} from '@wheeebo/polaris-api';
import {CircleLoader, LoadError, MemberPanel, VehiclePanel} from '@wheeebo/polaris-ui';

interface Props {
  vehicleId: Types.UUID;
  onMemberSelected: (memberId: Types.UUID) => void;
}

const VehicleProfileCard = ({vehicleId, onMemberSelected}: Props): JSX.Element => {
  const options: VehicleGetProps = {preload: ['owner']};
  const {data, isLoading, isError} = useQuery(API.Vehicles.getKey(vehicleId, options), () =>
    API.Vehicles.get(vehicleId, options),
  );
  return (
    <Card variant="outlined">
      <CardHeader title="Vehicle Profile" />
      <CardContent>
        {isLoading ? <CircleLoader /> : null}
        {isError ? <LoadError /> : null}
        {data ? (
          <Stack gap={1}>
            <VehiclePanel vehicleId={vehicleId} showVehicleType />
            <TextField disabled fullWidth variant="standard" label="Vehicle ID" value={data?.id} />
            <Box>
              <Typography variant="caption">Owner</Typography>
              {data?.owner?.id ? (
                <MemberPanel memberId={data.owner.id} onClick={() => onMemberSelected(data.owner?.id || '')} />
              ) : null}
            </Box>
          </Stack>
        ) : (
          <Typography variant="body2">No record found.</Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(VehicleProfileCard);
